<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>
          {{ $t("text.addStaff.title") }}
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <label class="uplift">{{
            $t("text.editStaff.personalInformation")
          }}</label>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.firstName") }}
                </span>
              </label>
              <div class="input__block" ref="fname_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.firstName')"
                  v-model="firstName"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="fname_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.lastName") }}
                </span>
              </label>
              <div class="input__block" ref="lname_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.lastName')"
                  class="form-control"
                  v-model="lastName"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="lname_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.cardName") }}
                </span>
              </label>
              <div class="input__block" ref="card_name_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.cardName')"
                  v-model="cardName"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="card_name_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.dateOfBirth") }}
                </span>
              </label>
              <div class="input__block">
                <input
                  type="date"
                  v-model="date"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <!-- <span>
                  <img src="@/assets/img/surface1.png" width="25px" />
                </span> -->
                {{ $t("text.editStaff.gender") }}
              </label>
              <div class="input__block">
                <select v-model="gender">
                  <option value="Male">{{ $t("text.editStaff.male") }}</option>
                  <option value="Female">
                    {{ $t("text.editStaff.female") }}
                  </option>
                </select>
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.email") }}
                </span>
              </label>
              <div class="input__block" ref="email_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.email')"
                  v-model="email"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="email_error"></div>
            </div>
          </div>
        </div>
        <div class="contact">
          <label class="uplift">{{
            $t("text.editStaff.contactInformation")
          }}</label>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.streetAddress") }}
                </span>
              </label>
              <div class="input__block" ref="street_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.streetAddress')"
                  v-model="street"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="street_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.city") }}
                </span>
              </label>
              <div class="input__block" ref="city_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.city')"
                  v-model="city"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="city_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                {{ $t("text.editStaff.state") }}
              </label>
              <div class="input__block">
                <select v-model="state">
                  <option :value="st.name" v-for="(st, i) in states" :key="i">
                    {{ st.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.country") }}
                </span>
              </label>
              <div class="input__block" ref="country_input">
                <input
                  style="width: 100%"
                  type="text"
                  :placeholder="this.$t('text.editStaff.country')"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                  v-model="country"
                  disabled
                />
              </div>
              <div ref="country_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6" style="margin: 0">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.phone") }}
                </span>
              </label>
              <div class="input__block" ref="phone_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.phone')"
                  style="width: 100%"
                  v-model="phone"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                />
              </div>
              <div ref="phone_error"></div>
            </div>
          </div>
        </div>

        <div class="text-center mt-4 pb-4">
          <button
            class="save__btn"
            @click="addStaff($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.addStaff.title") }} <span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";

import JQuery from "jquery";
let $ = JQuery;

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "VerifyReceipt",
  components: {
    MasterLayout,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      cardName: null,
      city: null,
      email: null,
      gender: null,
      street: null,
      state: "Lagos",
      phone: null,
      states: [],
      country: "Nigeria",
      branch: {},
      branchId: null,
      formIsValid: false,
      isButtonDisabled: false,
      date: "",
      showLoader: true,
      retainerships: null,
      backgroundUrl,
      payTime: "",
      fileDisabled: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
      }
      if (this.branchId !== null) {
        this.getStates();

        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
        function searchFun(event) {
          var grid =
            document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var value = event.target.value;
          grid.search(value);
        }
      }
    },
  },
  created() {
    document.title = "New Staff:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `New Staff:: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    captureFormEvents($event) {
      if ($event.target.placeholder === this.$t("text.editStaff.firstName")) {
        if ($event.target.value === "") {
          this.$refs.fname_error.style.display = "block";
          // this.$refs.fname_error.innerHTML =
          //   "Input First Name field cannot be blank";
          this.$refs.fname_input.style.border = "1px solid red";
          this.$refs.fname_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.fname_error.style.display = "none";
          this.$refs.fname_error.innerHTML = "";
          this.$refs.fname_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.editStaff.lastName")) {
        if ($event.target.value === "") {
          this.$refs.lname_error.style.display = "block";
          // this.$refs.lname_error.innerHTML = "Last Name field cannot be blank";
          this.$refs.lname_input.style.border = "1px solid red";
          this.$refs.lname_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.lname_error.style.display = "none";
          this.$refs.lname_error.innerHTML = "";
          this.$refs.lname_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if (
        $event.target.placeholder === this.$t("text.editStaff.streetAddress")
      ) {
        if ($event.target.value === "") {
          this.$refs.street_error.style.display = "block";
          // this.$refs.street_error.innerHTML = "Street Field cannot be blank";
          this.$refs.street_input.style.border = "1px solid red";
          this.$refs.street_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.street_error.style.display = "none";
          this.$refs.street_error.innerHTML = "";
          this.$refs.street_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.editStaff.city")) {
        if ($event.target.value === "") {
          this.$refs.city_error.style.display = "block";
          // this.$refs.city_error.innerHTML = "City Field cannot be blank";
          this.$refs.city_input.style.border = "1px solid red";
          this.$refs.city_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.city_error.style.display = "none";
          this.$refs.city_error.innerHTML = "";
          this.$refs.city_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.editStaff.country")) {
        if ($event.target.value === "") {
          this.$refs.country_error.style.display = "block";
          // this.$refs.country_error.innerHTML = "Country Field cannot be blank";
          this.$refs.country_input.style.border = "1px solid red";
          this.$refs.country_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.country_error.style.display = "none";
          this.$refs.country_error.innerHTML = "";
          this.$refs.country_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.editStaff.phone")) {
        if ($event.target.value === "") {
          this.$refs.phone_error.style.display = "block";
          // this.$refs.phone_error.innerHTML =
          //   "Phone Number field cannot be blank";
          this.$refs.phone_input.style.border = "1px solid red";
          this.$refs.phone_error.style.color = "red";
          this.formIsValid = false;
        } else {
          if (
            $event.target.value.length < 10 ||
            $event.target.value.length > 13
          ) {
            this.$refs.phone_error.style.display = "block";
            this.$refs.phone_error.style.color = "red";
            this.$refs.phone_input.style.border = "1px solid red";
            this.$refs.phone_error.innerHTML = this.$t(
              "text.errors.shortPhoneNumber"
            );
            this.formIsValid = false;
            return;
          }
          this.$refs.phone_error.style.display = "none";
          this.$refs.phone_input.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.editStaff.email")) {
        if ($event.target.value === "") {
          this.$refs.email_error.style.display = "block";
          // this.$refs.email_error.innerHTML = "Email field cannot be blank";
          this.$refs.email_input.style.border = "1px solid red";
          this.$refs.email_error.style.color = "red";
          this.formIsValid = false;
        } else {
          if (this.validEmail($event.target.value)) {
            this.$refs.email_error.style.display = "none";
            this.$refs.email_error.innerHTML = "";
            this.$refs.email_input.style.border = "1px solid rgb(75, 44, 114)";
            this.formIsValid = true;
          } else {
            this.$refs.email_error.style.color = "red";
            this.$refs.email_error.innerHTML = this.$t(
              "text.errors.invalidEmail"
            );
            this.$refs.email_input.style.border = "1px solid red";
            this.formIsValid = false;
          }
        }
      }
      if ($event.target.placeholder === this.$t("text.editStaff.cardName")) {
        if ($event.target.value === "") {
          this.$refs.card_name_error.style.display = "block";
          // this.$refs.card_name_error.innerHTML = "card field cannot be blank";
          this.$refs.card_name_input.style.border = "1px solid red";
          this.$refs.card_name_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.card_name_error.style.display = "none";
          this.$refs.card_name_error.innerHTML = "";
          this.$refs.card_name_input.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    getStates() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/States`,
          configObject.authConfig()
        )
        .then((response) => {
          this.states = response.data;
        })
        .catch((error) => {});
    },

    addStaff($event) {
      $event.preventDefault();
      if (!this.firstName) {
        this.$toast.open({
          message: this.$t("text.errors.firstNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.lastName) {
        this.$toast.open({
          message: this.$t("text.errors.lastNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.cardName) {
        this.$toast.open({
          message: this.$t("text.editStaff.cardNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.date) {
        this.$toast.open({
          message: this.$t("text.editStaff.dateOfBirthMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.gender) {
        this.$toast.open({
          message: this.$t("text.editStaff.genderMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.street) {
        this.$toast.open({
          message: this.$t("text.errors.streetMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.city) {
        this.$toast.open({
          message: this.$t("text.errors.cityMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.state) {
        this.$toast.open({
          message: this.$t("text.errors.stateMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.country) {
        this.$toast.open({
          message: this.$t("text.editStaff.countryMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.phone) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.phone.length < 10 || this.phone.length > 13) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      let newDate = new Date(this.date);
      let data;
      data = {
        firstName: this.firstName,
        lastName: this.lastName,
        dateOfBirth: newDate.toISOString(),
        gender: this.gender,
        cardName: this.cardName,
        street: this.street,
        phone: this.phone,
        email: this.email,
        city: this.city,
        state: this.state,
        country: this.country,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Staff/CreateStaff/${this.branchId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$eventHub.$emit("refreshStaffTable");
          this.$router.push({
            name: "staff",
            query: this.$route.query.branchId
              ? {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                }
              : null,
          });
          this.$toast.open({
            message: this.$t("text.addStaff.successfullyAdded"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.addStaff.unsuccessfulAdd"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
